// extracted by mini-css-extract-plugin
export default {"wrapper":"index_wrapper__mfqeS","logo":"index_logo__unKA0","back":"index_back__hzgZJ","tabs":"index_tabs__9H8ns","on":"index_on__YckOV"};